// extracted by mini-css-extract-plugin
export var phone = "_37-0";